import { initFlashcards } from './flashcards';
import { initMobileNav } from './mobile-nav';
import { initQuestaoBlocks } from './questao-block';

document.addEventListener('DOMContentLoaded', () => {
    initFlashcards();
    initMobileNav();
    initQuestaoBlocks();
});
